@if (canLogBackAsSupervisor) {
  <div class="logback-header">
    <div class="logback-header__role-info">
      <qima-icon [qimaIconName]="qimaIconNames.USER" [qimaIconSize]="16"></qima-icon>
      {{ 'one-isp-inspection-logback-header.logged-as-inspector' | translate }}
    </div>
    @if (canLogBackAsSupervisor) {
      <qima-button
        class="logback-header__action"
        [qimaButtonLabel]="'one-isp-inspection-logback-header.log-back-bo' | translate"
        [qimaButtonSize]="qimaButtonSizes.SMALL"
        [qimaButtonIconName]="qimaIconNames.LOGOUT"
        (qimaButtonClick)="logBackAsSupervisor()"
      ></qima-button>
    }
  </div>
}
